import { AutoPolicy } from '@aaa-ncnu-ie/mypolicy-api-policies';
import { Stack } from '@mui/material';
import React from 'react';

import CardWrapper from '../../CardWrapper';
import PolicyCoverageDetails from './PolicyCoverageDetails';
import VehicleCoverageDetails from './VehicleCoverageDetails';

interface CoveragesCardProps {
  data: AutoPolicy;
  isNanoPolicy?: boolean;
}

const CoveragesCard: React.FC<CoveragesCardProps> = ({
  data,
  isNanoPolicy,
}: CoveragesCardProps) => {
  return (
    <CardWrapper data-testid="autoCoverageWrapper" title="Coverages">
      <Stack
        spacing={{ mobile: 2, tablet: 3 }}
        sx={{
          width: 1,
        }}
      >
        <PolicyCoverageDetails
          vehicleCoverages={data.vehicleCoverages}
          policyCoverages={data.policyCoverages}
          policyNumber={data.policySummary.policyNumber}
        />
        {!isNanoPolicy &&
          data.vehicleCoverages.map((item, idx) => (
            <VehicleCoverageDetails
              key={`${item.year}-${item.make}-${item.series}-${idx}`}
              policyCoverages={data.policyCoverages}
              data={item}
              policyNumber={data.policySummary.policyNumber}
            />
          ))}
      </Stack>
    </CardWrapper>
  );
};

export default CoveragesCard;
